// 中文语言路由表
export default [
    {
        path: '/chinese/yachtTours',
        component: () => import('@/views/Tours/Chinese/Tours.vue'),
    },
    {
        path: '/chinese/super-yacht-rental-dubai',
        component: () => import('@/views/Super_yachts/Chinese/Super_yachts.vue'),
    },
    {
        path: '/chinese/water-sports-dubai',
        component: () => import('@/views/Water_sports/Chinese/teach.vue'),
    },
    {
        path: '/chinese/contact',
        component: () => import('@/views/Office/Chinese/Office'),
    },
    {
        path: '/chinese/bookOrder',
        component: () => import('@/views/Fun/Chinese/Fun.vue'),
    },
    {
        path: '/chinese/fishing-dubai',
        component: () => import('@/views/Fishing/Chinese/Fishing'),
    },
    {
        path: '/chinese/team',
        component: () => import('@/views/Company/Chinese/Company.vue'),
    },
]
